function readEnv(key: string): string | undefined {
  const value = process.env[key];
  if (typeof value === "string" && value.trim().length > 0) {
    return value.trim();
  }
  return undefined;
}

function isLoopbackHost(hostname: string): boolean {
  const lowered = hostname.toLowerCase();
  return lowered === "localhost" || lowered === "127.0.0.1" || lowered === "::1" || lowered === "[::1]";
}

function resolveBrowserFallbackApiBaseUrl(): string | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }

  const host = window.location.hostname;
  if (!host || !isLoopbackHost(host)) {
    return undefined;
  }

  const protocol = window.location.protocol === "https:" ? "https:" : "http:";
  return `${protocol}//${host}:5000`;
}

function requireEnv(keys: string[]): string {
  for (const key of keys) {
    const value = readEnv(key);
    if (value) {
      return value;
    }
  }

  const browserFallback = resolveBrowserFallbackApiBaseUrl();
  if (browserFallback) {
    return browserFallback;
  }

  throw new Error(
    `API base URL tanımlı değil. Lütfen ${keys.join(" veya ")} değerlerinden birini .env dosyanızda belirtin.`,
  );
}

function normalizeApiBaseUrl(raw: string): string {
  return raw.replace(/\/+$/, "").replace(/\/api$/i, "");
}

export const apiBaseUrl: string = normalizeApiBaseUrl(requireEnv(["VITE_API_URL", "REACT_APP_API_URL"]));

export const authJwtCookieName: string =
  readEnv("VITE_AUTH_JWT_COOKIE_NAME") ??
  readEnv("REACT_APP_AUTH_JWT_COOKIE_NAME") ??
  "jwt";

export const authCsrfCookieName: string =
  readEnv("VITE_AUTH_CSRF_COOKIE_NAME") ??
  readEnv("REACT_APP_AUTH_CSRF_COOKIE_NAME") ??
  "csrf-token";

const assetBaseFallback = readEnv("VITE_ASSET_BASE_URL") ?? readEnv("REACT_APP_ASSET_BASE_URL") ?? apiBaseUrl;
export const assetBaseUrl: string = String(assetBaseFallback).replace(/\/$/, "");
